<template>
    <div v-if="event.faqs">
        <collapse :multiple-active="false">
            <collapse-item
                v-for="(faq, index) in event.faqs"
                :key="faq.id + '-' + index">
                <template #title>
                    <span class="h3 mb-0">{{ faq.question }}</span>
                </template>
                <div v-html="faq.answer" />
            </collapse-item>
        </collapse>
    </div>
</template>

<script>

export default {
    name: "EventEntryFaq",
    props: {
        event: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
